import React, { useMemo, useState } from 'react';

const VariableSelector = ({ vars = [], tags = [], localVars = [], onVariableSelect }) => {
  const [search, setSearch] = useState('');
  const items = useMemo(() => {
    const all = [...vars, ...tags, ...localVars];
    if (!search) return all;
    const s = search.toLowerCase();
    return all.filter(v => (v.name || v.varName || v.tagName || '').toLowerCase().includes(s));
  }, [vars, tags, localVars, search]);

  const getDisplayName = (v) => {
    if (v.type === 'T') {
      const tagId = v.tagId !== undefined ? v.tagId : v.tagID;
      return `${v.tagName || v.name} [${tagId}]`;
    } else if (v.type === 'V') {
      const varId = v.varId !== undefined ? v.varId : v.varID;
      return `${v.varName || v.name} [${varId}]`;
    }
    return v.varName || v.tagName || v.name;
  };

  return (
    <div>
      <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Ara..." style={{ width: '100%', padding: 8, marginBottom: 8 }} />
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, maxHeight: 240, overflow: 'auto' }}>
        {items.map((v, i) => (
          <button key={i} onClick={() => onVariableSelect(v)} style={{ padding: '4px 8px', border: '1px solid #ddd', borderRadius: 4, cursor: 'pointer' }}>
            {getDisplayName(v)}
          </button>
        ))}
      </div>
    </div>
  );
};

export default VariableSelector;

